import { Cookie } from 'lucide-react';
import { useState } from 'react';

export function RGPDButton() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 text-sm font-medium transition-colors hover:opacity-80"
        style={{ color: 'var(--wcag-text)' }}
        aria-label="Gestion des cookies et RGPD"
      >
        <Cookie className="w-4 h-4" />
        <span>Cookies & RGPD</span>
      </button>

      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
          onClick={() => setShowModal(false)}
        >
          <div
            className="rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto"
            style={{ backgroundColor: 'var(--wcag-bg)' }}
            onClick={e => e.stopPropagation()}
          >
            <div className="p-6">
              {/* En-tête */}
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <Cookie className="w-8 h-8" style={{ color: 'var(--wcag-primary)' }} />
                  <h2 className="text-2xl font-bold" style={{ color: 'var(--wcag-text)' }}>
                    Gestion des cookies et RGPD
                  </h2>
                </div>
                <button
                  onClick={() => setShowModal(false)}
                  className="p-2 rounded-lg transition-colors hover:opacity-80"
                  style={{ color: 'var(--wcag-text)' }}
                  aria-label="Fermer"
                >
                  ✕
                </button>
              </div>

              {/* Contenu */}
              <div className="space-y-6" style={{ color: 'var(--wcag-text)' }}>
                <section>
                  <h3 className="text-lg font-semibold mb-2">Respect de votre vie privée</h3>
                  <p className="text-sm opacity-90">
                    Arnaqu'Quiz est un projet éducatif qui respecte votre vie privée. Nous
                    n'utilisons aucun tracker, aucune publicité, et ne collectons aucune donnée
                    personnelle.
                  </p>
                </section>

                <section
                  className="border rounded-lg p-4"
                  style={{ borderColor: 'var(--wcag-border)' }}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-semibold">Cookies essentiels</h4>
                    <span
                      className="text-sm px-3 py-1 rounded-full"
                      style={{
                        backgroundColor: 'var(--wcag-primary)',
                        color: 'var(--wcag-primary-text)',
                      }}
                    >
                      Toujours actifs
                    </span>
                  </div>
                  <p className="text-sm opacity-90">
                    Ces cookies sont nécessaires au fonctionnement du site. Ils permettent de :
                  </p>
                  <ul className="list-disc list-inside text-sm opacity-90 mt-2 space-y-1">
                    <li>Sauvegarder votre préférence de thème (clair/sombre)</li>
                    <li>Mémoriser votre consentement aux cookies</li>
                  </ul>
                  <p className="text-xs opacity-75 mt-2">
                    Stockage : LocalStorage du navigateur uniquement
                  </p>
                </section>

                <section
                  className="border rounded-lg p-4"
                  style={{ borderColor: 'var(--wcag-border)' }}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-semibold">Cookies analytiques</h4>
                    <span
                      className="text-sm px-3 py-1 rounded-full opacity-50"
                      style={{ borderColor: 'var(--wcag-border)', border: '1px solid' }}
                    >
                      Non utilisés
                    </span>
                  </div>
                  <p className="text-sm opacity-90">
                    Nous n'utilisons aucun outil d'analyse, de tracking ou de statistiques.
                  </p>
                </section>

                <section
                  className="border rounded-lg p-4"
                  style={{ borderColor: 'var(--wcag-border)' }}
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-semibold">Cookies publicitaires</h4>
                    <span
                      className="text-sm px-3 py-1 rounded-full opacity-50"
                      style={{ borderColor: 'var(--wcag-border)', border: '1px solid' }}
                    >
                      Non utilisés
                    </span>
                  </div>
                  <p className="text-sm opacity-90">
                    Ce site ne contient aucune publicité et ne partage aucune donnée avec des tiers.
                  </p>
                </section>

                <section>
                  <h3 className="text-lg font-semibold mb-2">Vos droits (RGPD)</h3>
                  <p className="text-sm opacity-90">
                    Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de
                    suppression de vos données. Comme nous ne collectons aucune donnée personnelle,
                    vous pouvez à tout moment effacer les données locales en vidant le cache de
                    votre navigateur.
                  </p>
                </section>

                <section>
                  <h3 className="text-lg font-semibold mb-2">Données stockées localement</h3>
                  <div className="text-sm opacity-90 space-y-2">
                    <p>Voici ce qui est actuellement stocké dans votre navigateur :</p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>
                        <code
                          className="px-2 py-1 rounded"
                          style={{ backgroundColor: 'var(--wcag-card-bg)' }}
                        >
                          theme
                        </code>{' '}
                        : votre préférence de thème (light/dark)
                      </li>
                      <li>
                        <code
                          className="px-2 py-1 rounded"
                          style={{ backgroundColor: 'var(--wcag-card-bg)' }}
                        >
                          cookie-consent
                        </code>{' '}
                        : votre choix de consentement
                      </li>
                    </ul>
                    <button
                      onClick={() => {
                        if (
                          confirm(
                            'Voulez-vous vraiment effacer toutes les données locales ? Vos préférences seront perdues.'
                          )
                        ) {
                          localStorage.clear();
                          alert('Données effacées. La page va se recharger.');
                          window.location.reload();
                        }
                      }}
                      className="mt-3 px-4 py-2 rounded-lg font-medium transition-all duration-200 border-2"
                      style={{
                        color: 'var(--wcag-danger)',
                        borderColor: 'var(--wcag-danger)',
                        backgroundColor: 'transparent',
                      }}
                    >
                      Effacer toutes les données
                    </button>
                  </div>
                </section>
              </div>

              {/* Bouton de fermeture */}
              <div
                className="flex justify-end mt-6 pt-6 border-t"
                style={{ borderColor: 'var(--wcag-border)' }}
              >
                <button
                  onClick={() => setShowModal(false)}
                  className="px-6 py-3 rounded-lg font-medium transition-all duration-200 border-2"
                  style={{
                    backgroundColor: 'var(--wcag-primary)',
                    color: 'var(--wcag-primary-text)',
                    borderColor: 'var(--wcag-primary)',
                  }}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
